
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { namespace } from "vuex-class";
const profile = namespace("profile");

@Component({
  computed: {
    ...mapGetters(["profileData", "trainingVideos"]),
    filteredTrainingVideos() {
      if (this.location?.length && this.trainingVideos?.length > 0) {
        let filtered = this.trainingVideos?.filter((x: any) => x.Location == this.location && x.LocationType == this.type);
        if (filtered && filtered.length) {
          this.TVALTooltipText = filtered[0].TVALTooltipText;
          this.DisplayText = filtered[0].DisplayText;
        }

        filtered?.sort((a: any, b: any) => a.DisplayOrder < b.DisplayOrder ? -1 : 1);
        return filtered;
      }
      else {
        return null;
      }
    }
  },
})
export default class TrainingVideos extends Vue {
  @profile.State
  public profileData: any;

  @profile.State
  public trainingVideos: any;

  public isTrainingVideoListVisible: boolean = false;
  public TVALTooltipText: string = '';
  public DisplayText: string = '';

  @Prop({ required: true }) readonly location!: string;
  @Prop({ required: true }) readonly type!: string;
  @Prop() readonly tooltipClass!: string;

  openVideoLink() {
    if (this.location != "" && this.trainingVideos != null) {
      let getPath = this.trainingVideos?.find((x: any) => x.Location == this.location && x.LocationType == this.type)?.path;
      console.log(getPath);
      this.openVideo(getPath);
    }
  }

  openVideo(path: any) {
    window.open(path, '', 'addressbar=false,toolbar=false,width=900,height=600,left=200,top=200,resizable=yes,title=Learn How');
    this.isTrainingVideoListVisible = false;
  }

  displayTrainingList(e: any) {
    this.isTrainingVideoListVisible = !this.isTrainingVideoListVisible;
  }
}
